import { Injectable } from '@angular/core';
import { IMyDateModel, IMyInputFieldChanged } from 'mydatepicker';
@Injectable({
  providedIn: 'root'
})
export class DateService {
  constructor(
    ) { }
    inputFeildchange(event: IMyInputFieldChanged) {
      let value = event.value;
      if (value.length == 5 && value.substring(2, 3) != '/') {
        return value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
      }
    }
    Datechange(event: IMyDateModel) {
      return event.formatted;
    }
    newone() {
    }
    inputFeildchangeReturnall(event: IMyInputFieldChanged) {
      let value = event.value;
      if (value.length == 5 && value.substring(2, 3) != '/') {
        return value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
      }
      else if (value.length == 10 && value.substring(2, 3) == '/' && value.substring(5, 6) == '/') {
        return value;
      }
    }
}
